module.exports = __webpack_public_path__ + "static/img/temp.0c656b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/navigation/image/temp.png
// module id = 0HRT
// module chunks = 0